// assets/guidebook-cover-cards.js
// Guide Book PDP only (see sections/main-product.liquid). The variant picker markup is
// generated at runtime by the variant-button custom element in app.js, so this decorates
// the labels it produces rather than replacing them - selection, price, gallery and
// sold-out handling all stay with app.js / pdp-oos-variant-select.js.
(function () {
  const wrapper = document.querySelector('.guidebook-cover-cards');
  if (!wrapper) return;

  const fieldset = wrapper.querySelector('fieldset#Color');
  if (!fieldset) return;

  const supportingText = wrapper.dataset.supportingText || '';
  let observer = null;

  function getVariants() {
    const root = document.getElementById('product-options');
    return (root && root.variants) || [];
  }

  function getSoldOutLabel() {
    const buyButton = document.querySelector('.product__info-container buy-button');
    return (
      (buyButton && buyButton.dataset.soldOutLabel) ||
      (window.MarketFilter && window.MarketFilter.soldOutLabel) ||
      'Sold out'
    );
  }

  function formatPrice(variant) {
    // Same formatting as the Add to cart button in app.js
    return `${variant.symbol}${(variant.price / 100).toFixed(2).replace(/\.00$/, '')}`;
  }

  function el(tag, className, text) {
    const node = document.createElement(tag);
    node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function buildCards() {
    const variants = getVariants();

    if (observer) observer.disconnect();

    fieldset.querySelectorAll('label.swatch').forEach((label) => {
      if (label.dataset.gbCard) return;

      const input = document.getElementById(label.getAttribute('for'));
      if (!input) return;

      const variantId = input.getAttribute('idvalue');
      const variant = variants.find((v) => String(v.id) === String(variantId));
      if (!variant) return;

      // app.js draws a diagonal strike for unavailable variants; the badge replaces it
      const strike = label.querySelector(':scope > div.absolute.inset-0');
      if (strike) strike.remove();

      const body = el('div', 'gb-cover-card__body');

      const title = label.querySelector('.swatch-card-label');
      if (title) body.appendChild(title);

      const pill = el('span', 'gb-cover-card__pill');
      pill.appendChild(el('span', 'gb-cover-card__pill-idle', 'Select cover'));
      pill.appendChild(el('span', 'gb-cover-card__pill-active', '✓ Selected'));
      body.appendChild(pill);

      body.appendChild(el('span', 'gb-cover-card__price', formatPrice(variant)));

      if (supportingText) {
        body.appendChild(el('span', 'gb-cover-card__support', supportingText));
      }

      label.appendChild(body);

      if (variant.available === false) {
        label.appendChild(el('span', 'gb-cover-card__badge', getSoldOutLabel()));
      }

      label.dataset.gbCard = 'true';
    });

    if (observer) observer.observe(fieldset, { childList: true, subtree: true });
  }

  buildCards();

  observer = new MutationObserver(buildCards);
  observer.observe(fieldset, { childList: true, subtree: true });
})();
